// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13Uvb","title":"Info_title__IQop8","links":"Info_links__1oXA1","link":"Info_link__RyLnt","logo":"Info_logo__2ukd8"};